import { SkeletonText } from '@libs/ui/ds/lib/components/feedback/Skeleton/specialized/SkeletonText/base/SkeletonText'
import { useMediaQueryThreshold } from '@libs/ui/ds/lib/theme'
import type { Cell } from '@tanstack/react-table'
import { cva } from 'class-variance-authority'
import type { FC, PropsWithChildren } from 'react'

import { tableClasses } from '../tableClasses'

const tableRowCellCVA = {
  cell: cva([], {
    variants: {
      align: {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right'
      },
      borderRight: {
        true: 'border-r-1 border-neutral-200'
      },
      cellsPaddingSize: {
        s: tableClasses.smallCell,
        m: tableClasses.cell
      }
    }
  })
}

type Props = {
  loading?: boolean
  colSpan: number
  cell: Cell<any, unknown>
}

export const TableRowSubComponent: FC<PropsWithChildren<Props>> = ({
  loading,
  cell,
  colSpan,
  children
}) => {
  const { columnDef } = cell.column

  const match = useMediaQueryThreshold({
    mediaQueryTreshold: columnDef.meta?.hideOn
  })

  if (match) {
    return null
  }

  return (
    <td
      key={`${cell.id}_subComponent`}
      className={tableRowCellCVA.cell({
        className: columnDef.meta?.className,
        borderRight: columnDef.meta?.borderRight,
        align: columnDef.meta?.align
      })}
      colSpan={colSpan}
    >
      {loading && <SkeletonText size='xs' />}
      {!loading && children}
    </td>
  )
}
